// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-month-picker .mat-calendar-period-button {
  pointer-events: none;
}

.example-month-picker .mat-calendar-arrow {
  display: none;
}

::ng-deep .white .mat-form-field-wrapper {
  padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/month-year-picker/month-year-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAGE;EACE,iBAAA;AAAJ","sourcesContent":[".example-month-picker .mat-calendar-period-button {\n  pointer-events: none;\n}\n  \n.example-month-picker .mat-calendar-arrow {\n  display: none;\n}\n\n::ng-deep {\n  .white .mat-form-field-wrapper{\n    padding-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
